// extracted by mini-css-extract-plugin
export default {"titleGroup":"MindoSertifikasi_titleGroup__S6GXL","titleContainer":"MindoSertifikasi_titleContainer__vcMfM","imageContainer":"MindoSertifikasi_imageContainer__Iylmo"};